var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getIsMobile)?_c('image-carousel',{staticClass:"grid-gallery_mobile",attrs:{"images":_vm.gallery_images}}):_c('div',{staticClass:"container"},[_c('gallery',{staticClass:"grid-gallery",attrs:{"images":_vm.gallery_images}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }